module.exports = __webpack_public_path__ + "img/img02.58ce467c.jpg";